import React, {useEffect, useState} from 'react';

import {fetchAssetByUrn} from '@deviceinsight/ng-ui-api-client';
import {DataProcessingDefinition} from '../../../../../../api/dataProcessingDefinitionApi';

import KpiSelectionTable from './KpiSelectionTable';
import {getUniqueKpisForAsset} from '../../kpiUtils';

type Props = {
	assetUrn: string;
	onKpiSelect: (arg0: DataProcessingDefinition) => void;
	'data-testid'?: string;
};

const KpiSearchComponent = ({assetUrn, onKpiSelect, ...restProps}: Props) => {
	const [loading, setLoading] = useState(true);
	const [kpis, setKpis] = useState<DataProcessingDefinition[]>([]);
	useEffect(() => {
		if (loading) {
			fetchAssetByUrn(assetUrn)
				.then(({id: assetId}) => getUniqueKpisForAsset(assetId))
				.then((kpis: Array<DataProcessingDefinition>) => {
					setKpis(kpis);
					setLoading(false);
				})
				.catch((error) => {
					console.error(error);
					setLoading(false);
				});
		}
	}, [assetUrn, loading]);
	return (
		<div data-testid={restProps['data-testid']}>
			<KpiSelectionTable kpis={kpis} isFetchingKpis={loading} onSelectKpi={onKpiSelect} />
		</div>
	);
};

export default KpiSearchComponent;
